import { eachObj } from '@/utils';

import { ElMessageBox, ElMessage } from 'element-plus';
import router from '@/router';
import store from '@/store';
import * as api from './api';
import createRequest from './createRequest';

/*
 *   createRequest
 *   @return (params, config) => Promise
 */

eachObj(api, (key, val) => {
  api[key].url = process.env.VUE_APP_BASEURL + val.url;
});

export const login = createRequest(api.login);

export const getPublicKey = createRequest(api.getPlulicKey);

export const getUserType = createRequest(api.getUserType);

export const getRouteList = createRequest(api.getRouteList);

export const getAccountList = createRequest(api.getAccountList);

export const getRoleSelectList = createRequest(api.getRoleSelectList);

export const addAccount = createRequest(api.addAccount);

export const getRoleList = createRequest(api.getRoleList);

export const getMenuTree = createRequest(api.getMenuTree);

export const getAppMenuTree = createRequest(api.getAppMenuTree);

export const addRole = createRequest(api.addRole);

export const delRole = createRequest(api.delRole);

export const getSellPointAuditList = createRequest(api.getSellPointAuditList);

export const saveEditAuditInfo = createRequest(api.saveEditAuditInfo);

export const passAudit = createRequest(api.passAudit);

export const rejectAudit = createRequest(api.rejectAudit);

export const getTrainingMaterialsAuditList = createRequest(api.getTrainingMaterialsAuditList);

export const getSellPointAndMaterialsList = createRequest(api.getSellPointAndMaterialsList);

export const getMerInfoList = createRequest(api.getMerInfoList);

export const checkProduct = createRequest(api.checkProduct);

export const batchAddMerInfo = createRequest(api.batchAddMerInfo);

export const delMerInfo = createRequest(api.delMerInfo);

export const getAppStarupConfigureList = createRequest(api.getAppStarupConfigureList);

export const addAppStarup = createRequest(api.addAppStarup);

export const delAppStarup = createRequest(api.delAppStarup);

export const updateAppSratupStatus = createRequest(api.updateAppSratupStatus);

export const getDictList = createRequest(api.getDictList);

export const getCarouselConfigureList = createRequest(api.getCarouselConfigureList);

export const addCarouselConfigure = createRequest(api.addCarouselConfigure);

export const delCarouselConfigure = createRequest(api.delCarouselConfigure);

export const getPlatformNoticeList = createRequest(api.getPlatformNoticeList);

export const getTeamList = createRequest(api.getTeamList);

export const getPersonList = createRequest(api.getPersonList);

export const saveNotice = createRequest(api.saveNotice);

export const deleteNotice = createRequest(api.deleteNotice);

export const getNoticeTypeList = createRequest(api.getNoticeTypeList);

export const getNoticeDetail = createRequest(api.getNoticeDetail);

export const noticeTopping = createRequest(api.noticeTopping);

export const getDownloadCenterList = createRequest(api.getDownloadCenterList);

export const deleteExportRecord = createRequest(api.deleteExportRecord);

export const getSalesmanList = createRequest(api.getSalesmanList);

export const getSalesmanDetail = createRequest(api.getSalesmanDetail);

export const getSalesmanRoleTypeList = createRequest(api.getSalesmanRoleTypeList);

export const getSalesmanTypeList = createRequest(api.getSalesmanTypeList);

export const getSupplierBranchList = createRequest(api.getSupplierBranchList);

export const addSalesmanMan = createRequest(api.addSalesmanMan);

export const getSalesmanSupplierInfo = createRequest(api.getSalesmanSupplierInfo);

export const disableSalesmanMan = createRequest(api.disableSalesmanMan);

export const inviteFaceRecognition = createRequest(api.inviteFaceRecognition);
export const cancelFaceRecognitionInvite = createRequest(api.cancelFaceRecognitionInvite);
export const getFaceRecognitionSuccessRecords = createRequest(api.getFaceRecognitionSuccessRecords);

export const getSalesmanApplyList = createRequest(api.getSalesmanApplyList);

export const getBranchList = createRequest(api.getBranchList);

export const getProjectList = createRequest(api.getProjectList);

export const getTeamTypeList = createRequest(api.getTeamTypeList);

export const getTeamOrderList = createRequest(api.getTeamOrderList);

export const freezeOrder = createRequest(api.freezeOrder);

export const getOrderDetail = createRequest(api.getOrderDetail);

export const checkOrderIsdelete = createRequest(api.checkOrderIsdelete);

export const exportForAsync = (payload) => {
  let dataUrl = api.exportForAsync.url;
  let paramsArr = [];
  payload.supUserId = store.state.user.supUserId;
  eachObj(payload, (key, val) => {
    paramsArr.push(`${key}=${val}`);
  });
  dataUrl = `${dataUrl}?${paramsArr.join('&')}`;
  createRequest(api.exportForAsync)({}, { params: { ...payload, dataUrl } }).then((data) => {
    if (data.success) {
      ElMessageBox.confirm('导出成功!是否前往下载中心查看', {
        title: '提示'
      }).then(() => {
        router.push({ name: 'DownloadCenter' });
      });
    } else {
      // ElMessage.error(data.msg);
    }
  });
};

export const getDownloadUrl = createRequest(api.getDownloadUrl);

export const getTeamOrderSummaryList = createRequest(api.getTeamOrderSummaryList);

export const getSalesmanOrderSummaryList = createRequest(api.getSalesmanOrderSummaryList);

export const getDeviceAuthList = createRequest(api.getDeviceAuthList);

export const updateDeviceAuth = createRequest(api.updateDeviceAuth);

export const setNote = createRequest(api.setNote);

export const getCusServiceInfo = createRequest(api.getCusServiceInfo);

export const saveCusServiceInfo = createRequest(api.saveCusServiceInfo);

export const savePwd = createRequest(api.savePwd);

export const getSalesmanCustomList = createRequest(api.getSalesmanCustomList);

export const getBindCusInfoList = createRequest(api.getBindCusInfoList);

export const getCustomerType = createRequest(api.getCustomerType);

export const getCustomerArea = createRequest(api.getCustomerArea);

export const getAddedCustomers = createRequest(api.getAddedCustomers);

export const getRemovedCustomers = createRequest(api.getRemovedCustomers);

export const getAreaTree = createRequest(api.getAreaTree);

export const addCustomerArea = createRequest(api.addCustomerArea);

export const getCustomerTypeList = createRequest(api.getCustomerTypeList);

export const addCustomerTypes = createRequest(api.addCustomerTypes);

export const getCustomerList = createRequest(api.getCustomerList);

export const addCustomerIds = createRequest(api.addCustomerIds);

export const delCustomer = createRequest(api.delCustomer);

export const saveCustomerAndValidateData = createRequest(api.saveCustomerAndValidateData);

export const clearRelation = createRequest(api.clearRelation);

export const getControlSalesTeamList = createRequest(api.getControlSalesTeamList);

export const getSupplierMerCount = createRequest(api.getSupplierMerCount);

export const getCatalog = createRequest(api.getCatalog);

export const getDistributorList = createRequest(api.getDistributorList);

export const mergeSupplier = createRequest(api.mergeSupplier);

export const getSmartkbTenants = createRequest(api.getSmartkbTenants);

export const bindSmartkbTenant = createRequest(api.bindSmartkbTenant);

export const getEditDistributorList = createRequest(api.getEditDistributorList);

export const getOrderAuditDivId = createRequest(api.getOrderAuditDivId);

export const getOrderauditMerchandise = createRequest(api.getOrderauditMerchandise);

export const getOrderCustomer = createRequest(api.getOrderCustomer);

export const getAuditPriceId = createRequest(api.getAuditPriceId);

export const updateOrderAutidDivId = createRequest(api.updateOrderAutidDivId);

export const getSalesmanBySupplierId = createRequest(api.getSalesmanBySupplierId);

export const createOrderauditMain = createRequest(api.createOrderauditMain);

export const deleteByAuditMainId = createRequest(api.deleteByAuditMainId);

export const getPersonnelReview = createRequest(api.getPersonnelReview);

export const updateOrderauditMain = createRequest(api.updateOrderauditMain);

export const getTheSupBranch = createRequest(api.getTheSupBranch);

export const getDrugInformation = createRequest(api.getDrugInformation);

export const insertOrderAutidDivId = createRequest(api.insertOrderAutidDivId);

export const deleteOrderAutidDivId = createRequest(api.deleteOrderAutidDivId);

export const getCustInformation = createRequest(api.getCustInformation);

export const insertOrderCustomer = createRequest(api.insertOrderCustomer);

export const deleteOrderCustomer = createRequest(api.deleteOrderCustomer);

export const getStructureTreeInfo = createRequest(api.getStructureTreeInfo);

export const getBusiAreeTree = createRequest(api.getBusiAreeTree);

export const addNextDeptInfo = createRequest(api.addNextDeptInfo);

export const editSaveDeptInfo = createRequest(api.editSaveDeptInfo);

export const updateSalesProdScope = createRequest(api.updateSalesProdScope);

export const deleteDept = createRequest(api.deleteDept);

export const sellingDrugsList = createRequest(api.sellingDrugsList);

export const getMerchandis4Sup = createRequest(api.getMerchandis4Sup);

export const getBranchSource = createRequest(api.getBranchSource);

export const getBranchSourceByBranchIds = createRequest(api.getBranchSourceByBranchIds);

export const addSupMer = createRequest(api.addSupMer);

export const deleteSupMer = createRequest(api.deleteSupMer);

export const getUserInfoByStructureId = createRequest(api.getUserInfoByStructureId);

export const getSalesmanListBySupplierId = createRequest(api.getSalesmanListBySupplierId);

export const saveSalesmanRelation = createRequest(api.saveSalesmanRelation);

export const removeRelation = createRequest(api.removeRelation);

export const exportUserInfo = createRequest(api.exportUserInfo);

export const getSalesManAreeTree = createRequest(api.getSalesManAreeTree);

export const saveSalesmanArea = createRequest(api.saveSalesmanArea);

export const getBillBranchWhiteList = createRequest(api.getBillBranchWhiteList);

export const getSalesmanIntegralInfoList = createRequest(api.getSalesmanIntegralInfoList);

export const integralExchange = createRequest(api.integralExchange);

export const batchIntegralExchange = createRequest(api.batchIntegralExchange);

export const getIntegralExchangeList = createRequest(api.getIntegralExchangeList);

export const getIntegralIncomeList = createRequest(api.getIntegralIncomeList);

export const getSpecifiedSalesmanType = createRequest(api.getSpecifiedSalesmanType);

export const getAcademicList = createRequest(api.getAcademicList);

export const getSupplierTreeInfo = createRequest(api.getSupplierTreeInfo);

export const getMerchandise = createRequest(api.getMerchandise);

export const updateAcademic = createRequest(api.updateAcademic);

export const backupDataByActivityId = createRequest(api.backupDataByActivityId);

export const getAcademicProjectDetail = createRequest(api.getAcademicProjectDetail);

export const delAcademic = createRequest(api.delAcademic);

export const publishAcademic = createRequest(api.publishAcademic);

export const finishAcademic = createRequest(api.finishAcademic);

export const getJoinNameList = createRequest(api.getJoinNameList);

export const getBranchCustInfoList = createRequest(api.getBranchCustInfoList);

export const getBranchBindingCustInfoList = createRequest(api.getBranchBindingCustInfoList);

export const bindingBranchCustRelation = createRequest(api.bindingBranchCustRelation);

export const getCategoryList = createRequest(api.getCategoryList);

export const updateDrugsCategory = createRequest(api.updateDrugsCategory);

export const saveCategory = createRequest(api.saveCategory);

export const sortCategory = createRequest(api.sortCategory);

export const delCategory = createRequest(api.delCategory);

export const getReportList = createRequest(api.getReportList);

export const getRepostProdList = createRequest(api.getRepostProdList);

export const getSurveyApplyList = createRequest(api.getSurveyApplyList);

export const getAreaListData = createRequest(api.getAreaListData);

export const getCommonCustomList = createRequest(api.getCommonCustomList);

export const getSurveyDataList = createRequest(api.getSurveyDataList);

export const saveSurveyData = createRequest(api.saveSurveyData);

export const auditSurveyApply = createRequest(api.auditSurveyApply);

export const batchAuditPass = createRequest(api.batchAuditPass);

export const getSalesmanSupplierList = createRequest(api.getSalesmanSupplierList);

export const getSalemanSupplier = createRequest(api.getSalemanSupplier);

export const relateTeam = createRequest(api.relateTeam);

export const getSupplierDeliveryConfig = createRequest(api.getSupplierDeliveryConfig);

export const saveSupplierDeleveryConfig = createRequest(api.saveSupplierDeleveryConfig);

export const getActivityMerchandiseList = createRequest(api.getActivityMerchandiseList);
export const getGroupActivityMerchandiseList = createRequest(api.getGroupActivityMerchandiseList);
export const activityGroupUpdate = createRequest(api.activityGroupUpdate);
export const getActivityGroupInfo = createRequest(api.getActivityGroupInfo);
export const getGroupActivityEditRecordList = createRequest(api.getGroupActivityEditRecordList);
export const getGroupActivityEditRecordDetail = createRequest(api.getGroupActivityEditRecordDetail);

export const activityUpdate = createRequest(api.activityUpdate);

export const getRedPacketList = createRequest(api.getRedPacketList);

export const removeActivity = createRequest(api.removeActivity);

export const endActivity = createRequest(api.endActivity);

export const getActivityInfo = createRequest(api.getActivityInfo);

export const getActivityWithdrawList = createRequest(api.getActivityWithdrawList);

export const exportActivityWithdrawList = createRequest(api.exportActivityWithdrawList);

export const activityBuygiveUpdate = createRequest(api.activityBuygiveUpdate);

export const getActivityBuygiveInfo = createRequest(api.getActivityBuygiveInfo);

export const getActivityEditRecordList = createRequest(api.getActivityEditRecordList);

export const getActivityEditRecordDetail = createRequest(api.getActivityEditRecordDetail);

export const getActivityInfoByProdNo = createRequest(api.getActivityInfoByProdNo);

export const getBranchInfoBySupplierId = createRequest(api.getBranchInfoBySupplierId);

export const searchBranchOwnerInfoList = createRequest(api.searchBranchOwnerInfoList);

export const searchSupplierOwnerInfoList = createRequest(api.searchSupplierOwnerInfoList);

export const searchSupplierBranchOwnerInfoList = createRequest(api.searchSupplierBranchOwnerInfoList);

export const searchBatchBranchOwnerInfoList = createRequest(api.searchBatchBranchOwnerInfoList);


export const saveSupplierInvoiceConfig = createRequest(api.saveSupplierInvoiceConfig);

export const saveSupplierOwnerConfig = createRequest(api.saveSupplierOwnerConfig);

export const saveSupplierOwnerInfo = createRequest(api.saveSupplierOwnerInfo);

export const getSupplierMerchandiseIntegraList = createRequest(
  api.getSupplierMerchandiseIntegraList
);

export const saveMerchandiseIntegralConfig = createRequest(api.saveMerchandiseIntegralConfig);

export const getSalesmanInvitationRelation = createRequest(api.getSalesmanInvitationRelation);

export const getVoteActivityList = createRequest(api.getVoteActivityList);

export const delVoteActivity = createRequest(api.delVoteActivity);

export const saveVoteActivity = createRequest(api.saveVoteActivity);

export const getOrderStateList = createRequest(api.getOrderStateList);

export const getDictItemList = createRequest(api.getDictItemList);

export const getArreactProdList = createRequest(api.getArreactProdList);

export const attractProductUpdateStatus = createRequest(api.attractProductUpdateStatus);

export const attractProductUpdateTop = createRequest(api.attractProductUpdateTop);

export const getAttractConfig = createRequest(api.getAttractConfig);

export const getAttractAreaList = createRequest(api.getAttractAreaList);

export const getProdCenterData = createRequest(api.getProdCenterData);

export const saveAttractProduct = createRequest(api.saveAttractProduct);

export const getAttractProductDetail = createRequest(api.getAttractProductDetail);

export const getAttractBannerList = createRequest(api.getAttractBannerList);

export const saveAttractBanner = createRequest(api.saveAttractBanner);

export const attractBannerUpdateStatus = createRequest(api.attractBannerUpdateStatus);

export const delAttractBanner = createRequest(api.delAttractBanner);

export const getAttractApplyList = createRequest(api.getAttractApplyList);

export const getAttractApplyDetail = createRequest(api.getAttractApplyDetail);

export const getVarietyList = createRequest(api.getVarietyList);
export const getVarietyDetail = createRequest(api.getVarietyDetail);
export const saveVariety = createRequest(api.saveVariety);
export const varietyUpdateStatus = createRequest(api.varietyUpdateStatus);
export const deleteVariety = createRequest(api.deleteVariety);
export const getVarietyGoodsList = createRequest(api.getVarietyGoodsList);

export const getRecruitNoticeList = createRequest(api.getRecruitNoticeList);
export const getRecruitNoticeDetail = createRequest(api.getRecruitNoticeDetail);
export const saveRecruitNotice = createRequest(api.saveRecruitNotice);
export const recruitNoticeUpdateStatus = createRequest(api.recruitNoticeUpdateStatus);
export const recruitNoticeUpdateTop = createRequest(api.recruitNoticeUpdateTop);
export const getRecruitAreaTree = createRequest(api.getRecruitAreaTree);
export const getRecruitApplyList = createRequest(api.getRecruitApplyList);
export const getRecruitPersonnelList = createRequest(api.getRecruitPersonnelList);
export const getRecruitPersonnelDetail = createRequest(api.getRecruitPersonnelDetail);
export const getRecruitBannerList = createRequest(api.getRecruitBannerList);
export const saveRecruitBanner = createRequest(api.saveRecruitBanner);
export const recruitBannerUpdateStatus = createRequest(api.recruitBannerUpdateStatus);

export const deleteRecruitBanner = createRequest(api.deleteRecruitBanner);

export const updateBottomPrice = createRequest(api.updateBottomPrice);

export const getSysAreaTree = createRequest(api.getSysAreaTree)

export const getTrackData = createRequest(api.trackData)
export const getTrackCountData = createRequest(api.trackCountData)
export const getTrackAccountDetail = createRequest(api.trackAccountDetail)

export const getBillAuth = createRequest(api.getBillAuth)

export const saveBillAuth = createRequest(api.saveBillAuth)

export const getApplySimilarCust = createRequest(api.getApplySimilarCust)

export const matchApplySimilarCust = createRequest(api.matchApplySimilarCust)
export const saveOrderAuditInfo = createRequest(api.saveOrderAuditInfo)
export const getOrderAuditInfo = createRequest(api.getOrderAuditInfo)
export const getAuditPerson = createRequest(api.getAuditPerson)
export const saveRefundAuditInfo = createRequest(api.saveRefundAuditInfo)
export const getRefundAuditInfo = createRequest(api.getRefundAuditInfo)
export const getRefundAuditPerson = createRequest(api.getRefundAuditPerson)
export const getSupPriceStrategy = createRequest(api.getSupPriceStrategy)
export const setSupPriceStrategy = createRequest(api.setSupPriceStrategy)
export const setSupMerchandiseSellStatus = createRequest(api.setSupMerchandiseSellStatus)
export const getOrderGatherList = createRequest(api.getOrderGatherList)
export const orderGatherExport = createRequest(api.orderGatherExport)
export const addressRecognition = createRequest(api.addressRecognition)
export const saveCancerOrderConfig = createRequest(api.saveCancerOrderConfig)
export const cancelOrders = createRequest(api.cancelOrders)

export const taskPublish = createRequest(api.taskPublish)
export const taskNoJoinUser = createRequest(api.taskNoJoinUser)
export const taskList = createRequest(api.taskList)
export const taskCancel = createRequest(api.taskCancel)
export const taskDetail = createRequest(api.taskDetail)
export const taskUserRecord = createRequest(api.taskUserRecord)
export const trainingCourseList = createRequest(api.trainingCourseList)
export const trainingPaperList = createRequest(api.trainingPaperList)
export const trainingCollectionList = createRequest(api.trainingCollectionList)
export const trainingCollectionBindings = createRequest(api.trainingCollectionBindings)
export const trainingAssignCollections = createRequest(api.trainingAssignCollections)
export const myProgresstList = createRequest(api.myProgresstList)
export const getSupplierTreeInfoByScienceId = createRequest(api.getSupplierTreeInfoByScienceId)
export const getGoalProdList = createRequest(api.getGoalProdList)
export const targetNoJoinUser = createRequest(api.targetNoJoinUser)
export const targetPublish = createRequest(api.targetPublish)
export const targetList = createRequest(api.targetList)
export const targetDetail = createRequest(api.targetDetail)
export const validTargetImport = createRequest(api.validTargetImport)

export const saveDynamicBusinessMenuStatus = createRequest(api.saveDynamicBusinessMenuStatus)
export const saveCustOrderCheck = createRequest(api.saveCustOrderCheck)

export const savePlatformServiceFee = createRequest(api.savePlatformServiceFee)

export const updateTeamPrice = createRequest(api.updateTeamPrice);

export const getMerchandiseBlacklistListBySupplierId = createRequest(api.getMerchandiseBlacklistListBySupplierId);

export const deleteMerchandiseBlacklistListBySupplierId = createRequest(api.deleteMerchandiseBlacklistListBySupplierId);

export const getMerchandiseBlacklistChooseListBySupplierId = createRequest(api.getMerchandiseBlacklistChooseListBySupplierId);

export const saveMerchandiseBlacklistListBySupplierId = createRequest(api.saveMerchandiseBlacklistListBySupplierId);

export const getSalesManCustWhiteList = createRequest(api.getSalesManCustWhiteList);

export const customerSearch = createRequest(api.customerSearch);

export const getSupMerchandiseOwnerStorage = createRequest(api.getSupMerchandiseOwnerStorage)

export const getPrizeManageList = createRequest(api.getPrizeManageList);

export const getPrizeMerchandiseList = createRequest(api.getPrizeMerchandiseList);

export const savePrizeManage = createRequest(api.savePrizeManage);

export const deletePrizeManage = createRequest(api.deletePrizeManage);

export const addPrizeCount = createRequest(api.addPrizeCount);

export const updatePrizePrice = createRequest(api.updatePrizePrice);

export const getPrizeEditRecordList = createRequest(api.getPrizeEditRecordList);
export const getPrizeExpireList = createRequest(api.getPrizeExpireList);
export const deductPrizeCount = createRequest(api.deductPrizeCount);

export const getLevelOneSupplierList = createRequest(api.getLevelOneSupplierList);

export const getLiveList = createRequest(api.getLiveList);

export const getLiveDetail = createRequest(api.getLiveDetail);

export const saveLive = createRequest(api.saveLive);

export const updateLiveStatus = createRequest(api.updateLiveStatus);

export const getLiveSubscribeList = createRequest(api.getLiveSubscribeList);

export const getPcMenuTree = createRequest(api.getPcMenuTree);
export const savePcMenu = createRequest(api.savePcMenu);
export const deletePcMenu = createRequest(api.deletePcMenu);
export const sortPcMenu = createRequest(api.sortPcMenu);
export const getBuiltinRoleList = createRequest(api.getBuiltinRoleList);
export const getBuiltinRoleMenuTree = createRequest(api.getBuiltinRoleMenuTree);
export const saveBuiltinRoleMenu = createRequest(api.saveBuiltinRoleMenu);
